import { createFileRoute } from '@tanstack/react-router';

import { ContactsPage } from '@/contacts/pages';
import { requireAuth } from '@/shared/auth';

export const Route = createFileRoute('/contacts/')({
  beforeLoad: ({ location, context }) => {
    requireAuth({ location, auth: context.auth });
  },
  component: ContactsRoute
});

function ContactsRoute() {
  return (
    <ContactsPage />
  );
}
